var renderType = 3;
export function setRenderType(type) {
    renderType = type;
}
export function isH5() {
    return renderType === 3;
}
export function isFlutter() {
    return renderType === 1;
}
export function isLynx() {
    return renderType === 2;
}
export function isClient() {
    return typeof window === 'object' || typeof NativeModules === 'object';
}
export function isServer() {
    return !isClient();
}
